import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isEventsRsvp(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.EVENTS_RSVP && typeof label === 'string' && typeof value === 'string';
}
function _formatEventsRsvp(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatEventsRsvp(submission) {
  if (isEventsRsvp(submission)) {
    return _formatEventsRsvp(submission);
  }
  return undefined;
}
//# sourceMappingURL=events-rsvp-preview.js.map